import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { FunctionsClient } from './types';
import * as yup from 'yup';
import { alphanumericRegex, regexOnlyNumber } from 'shell/constants/regex';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.FunzioneQuery],
  create: [SystemAuthorizations.FunzioneAdd],
  edit: [SystemAuthorizations.FunzioneUpdate],
  delete: [SystemAuthorizations.FunzioneDelete],
});

export const headCells: HeadCell<FunctionsClient, keyof FunctionsClient>[] = [
  {
    id: 'id',
    label: 'ID Funzione',
  },
  {
    id: 'function',
    label: 'Funzione',
  },
  {
    id: 'entity',
    label: 'Entità',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaToponymyFilter = yup.object({
  code: yup.string().nullable().notRequired().matches(regexOnlyNumber, 'Il campo è numerico'),
  description: yup
    .string()
    .nullable()
    .notRequired()
    .matches(alphanumericRegex, 'Il campo è alfanumerico'),
});
